'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _ditto = require('../components/product/ditto');

var _ditto2 = _interopRequireDefault(_ditto);

var _sliders = require('../components/product/sliders');

var _sliders2 = _interopRequireDefault(_sliders);

require('../components/product/prescription');

var _recommendations = require('../components/product/recommendations');

var _recommendations2 = _interopRequireDefault(_recommendations);

var _cartDrawer = require('../global/cart-drawer');

var _cartDrawer2 = _interopRequireDefault(_cartDrawer);

var _topBarFunctions = require('../global/top-bar-functions');

var _topBarFunctions2 = _interopRequireDefault(_topBarFunctions);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var scrollTop = 0;

var Product = function () {
  function Product() {
    (0, _classCallCheck3.default)(this, Product);

    var data = JSON.parse(document.getElementById('ShopifyData').innerHTML);
    var initialVariantId = Number(document.querySelector('.js-variant-id').value);
    var images = data.images,
        product = data.product;
    var variants = product.variants;

    // data

    this.product = product;
    this.variants = variants;
    this.images = images;
    this.prescriptionButton = 'customize prescription';
    this.addButton = 'add to cart';
    this.soldOutButton = 'sold out';
    this.initialVariant = variants.filter(function (variant) {
      return variant.id === initialVariantId;
    })[0];

    // variant selectors
    this.color = '.js-color';
    this.colorOption = '.js-color-option';
    this.colorTitle = '.js-color-selected';
    this.customize = '.js-customize';
    this.formVariant = '.js-variant-id';
    this.price = '.js-price';
    this.comparePrice = '.js-compare-price';
    this.colorTitleWrapper = '.js-color-title';
    this.colorSwatch = '.js-color-swatch';

    // description selectors
    this.tablist = '.js-tablist';
    this.descPanels = '.js-desc-panel';

    // non-prescription selectors
    this.submit = '.js-submit';

    // sliders init
    this.sliders = new _sliders2.default();

    // ditto init
    this.ditto = new _ditto2.default(this.initialVariant);

    // product init
    this.init(product);
  }

  (0, _createClass3.default)(Product, [{
    key: 'init',
    value: function init(product) {
      var submitButton = document.querySelector(this.submit);

      if (submitButton) {
        this.submitListener(submitButton);
      }
      this.initVariants();
      this.initDescription();
      new _recommendations2.default(product.id);
    }

    // ***************** //
    // Variant functions //
    // ***************** //

  }, {
    key: 'initVariants',
    value: function initVariants() {
      var _this = this;

      var self = this;
      var images = this.images,
          variants = this.variants;

      var selector = document.querySelector(this.color);
      var domVariants = document.querySelectorAll(this.colorOption);

      function addClickEvent(variant) {
        variant.addEventListener('click', function () {
          self.selectVariant(variant);
        });
        variant.addEventListener('keydown', function (event) {
          return event.keyCode === 13 ? self.selectVariant(variant) : false;
        });
      }

      function addSelectorEvent() {
        selector.addEventListener('click', function () {
          selector.classList.toggle('open');
        });
        selector.addEventListener('keydown', function (event) {
          return event.keyCode === 13 ? selector.classList.toggle('open') : false;
        });
      }

      // Filter out any lifestyle images
      images.map(function (image, index) {
        return image.color === 'lifestyle' ? images.splice(index, 1) : true;
      });
      this.images = images;

      // Append image data to appropriate variants - VARIANT OPTION 1 MUST BE COLOR (title is irrelevant)

      var _loop = function _loop(variant) {
        var variantImages = _this.images.filter(function (image) {
          return image.color.toLowerCase().trim() === variant.option1.toLowerCase().trim();
        });
        variant.images = variantImages;
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = variants[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var variant = _step.value;

          _loop(variant);
        }

        // Variant select click event
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      addSelectorEvent();

      // Variant button click event
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = domVariants[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var variant = _step2.value;

          addClickEvent(variant);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }, {
    key: 'selectVariant',
    value: function selectVariant(button) {
      var variants = this.variants,
          ditto = this.ditto,
          colorTitle = this.colorTitle,
          colorOption = this.colorOption,
          colorTitleWrapper = this.colorTitleWrapper,
          colorSwatch = this.colorSwatch;

      var title = document.querySelector(colorTitle);
      var titleWrapper = document.querySelector(colorTitleWrapper);
      var swatch = document.querySelector(colorSwatch);
      var allButtons = document.querySelectorAll(colorOption);
      var variantId = Number(button.dataset.variantId);
      var variantData = variants.filter(function (variant) {
        return variant.id === variantId;
      })[0];
      var variantPrice = this.formattedPrice(variantData.price);
      var variantCompareAtPrice = this.formattedPrice(variantData.compare_at_price);
      var dittoSlide = document.getElementById('dittoDisplay');
      var colorInit = window.location.href.split('?')[0];
      var colorURL = colorInit + "?variant=" + variantId;

      window.location.href = colorURL;

      // Add active state
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = allButtons[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var option = _step3.value;

          option.classList.remove('selected');
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      button.classList.add('selected');

      // Change selector title
      title.innerText = variantData.option1;
      swatch.dataset.handleName = variantData.option1.toLowerCase().trim().replace(/\s/, '-');

      if (variantData.available) {
        titleWrapper.classList.remove('unavailable');
        this.availableButton(true);
      } else {
        titleWrapper.classList.add('unavailable');
        this.availableButton(false);
      }

      // Update price
      document.querySelector(this.price).innerText = variantPrice;
      document.querySelector(this.comparePrice).innerText = variantCompareAtPrice === 'P0' ? '' : variantCompareAtPrice;

      // Update image gallery
      this.sliders.rebuildSlick(variantData.images);

      // Update form variant ID
      document.querySelector(this.formVariant).value = variantId;

      // Update ditto image
      if (dittoSlide) {
        ditto.addUpdateSlide(variantData);
      }
    }

    // ********************* //
    // Description functions //
    // ********************* //

  }, {
    key: 'initDescription',
    value: function initDescription() {
      var self = this;
      var tablist = document.querySelector(this.tablist);
      var buttons = tablist.querySelectorAll('button');

      function addClickEvent(button) {
        button.addEventListener('click', function () {
          var allTabs = document.querySelectorAll(self.descPanels);
          var buttonTab = document.querySelector('#' + button.id + '-tab');

          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = allTabs[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var tab = _step4.value;

              tab.setAttribute('hidden', '""');
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }

          buttonTab.removeAttribute('hidden');

          var _iteratorNormalCompletion5 = true;
          var _didIteratorError5 = false;
          var _iteratorError5 = undefined;

          try {
            for (var _iterator5 = buttons[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
              var oldButtons = _step5.value;

              oldButtons.classList.remove('active');
            }
          } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
              }
            } finally {
              if (_didIteratorError5) {
                throw _iteratorError5;
              }
            }
          }

          button.classList.add('active');
        });

        button.addEventListener('keydown', function (event) {
          var allTabs = document.querySelectorAll(self.descPanels);
          var buttonTab = document.querySelector('#' + button.id + '-tab');

          if (event.keyCode !== 13) {
            return false;
          }

          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = allTabs[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var tab = _step6.value;

              tab.setAttribute('hidden', '""');
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }

          buttonTab.removeAttribute('hidden');

          var _iteratorNormalCompletion7 = true;
          var _didIteratorError7 = false;
          var _iteratorError7 = undefined;

          try {
            for (var _iterator7 = buttons[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
              var oldButtons = _step7.value;

              oldButtons.classList.remove('active');
            }
          } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion7 && _iterator7.return) {
                _iterator7.return();
              }
            } finally {
              if (_didIteratorError7) {
                throw _iteratorError7;
              }
            }
          }

          button.classList.add('active');
          return true;
        });
      }

      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = buttons[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var button = _step8.value;

          addClickEvent(button);
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }
    }

    // **************** //
    // Helper functions //
    // **************** //

  }, {
    key: 'formattedPrice',
    value: function formattedPrice(price) {
      return 'P' + parseFloat(price / 100).toFixed(2).replace('.00', '');
    }
  }, {
    key: 'availableButton',
    value: function availableButton(available) {
      var product = this.product;

      var button = document.querySelector(this.customize);
      var tags = product.tags.map(function (tag) {
        return tag.toLowerCase();
      });
      var prescription = tags.includes('prescription');

      button.classList.remove('disabled');

      if (available && prescription) {
        button.innerText = this.prescriptionButton;
      } else if (available && !prescription) {
        button.innerText = this.addButton;
      } else {
        button.innerText = this.soldOutButton;
        button.classList.add('disabled');
      }
    }
  }, {
    key: 'submitListener',
    value: function submitListener(button) {
      var self = this;
      var form = button.closest('form');

      button.addEventListener('click', function () {
        self.submitForm(form);
      });
      button.addEventListener('keydown', function (event) {
        return event.keyCode === 13 ? self.submitForm(form) : false;
      });
    }
  }, {
    key: 'submitForm',
    value: function submitForm(form) {
      var url = '/cart/add.js';
      var id = form.querySelector(this.formVariant).value;
      var data = { id: id, quantity: 1 };
      var cartDrawer = document.querySelector('.cart-drawer');

      _axios2.default.post(url, data).then(function (results) {
        (0, _cartDrawer2.default)(true);
        cartDrawer.classList.add('expanded');
        (0, _topBarFunctions2.default)();
        (0, _jquery2.default)('html').addClass('no-scroll');

        scrollTop = (0, _jquery2.default)(window).scrollTop();
        (0, _jquery2.default)('body').attr('data-top', (0, _jquery2.default)(window).scrollTop()).css('top', -scrollTop);
        return true;
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }]);
  return Product;
}();

exports.default = Product;